import React, { useEffect } from "react";
import { NavLink  } from "react-router-dom";

function StoreSidebar({navbar}) {  
    useEffect(() =>{
        setTimeout(() => {
            document.querySelector(".sideBar").style.top = `${navbar}px`;
            document.querySelector(".sideBar").style.height = `${window.innerHeight - navbar}px`;
          }, 300);
    })
  return (
    <aside className="sideBar bg-white d-flex flex-column">
        <ul className="list-unstyled sideBar_menu">
            <li>
                <NavLink  to="/store-profile"><em className="gg-home"></em> Profile</NavLink>
            </li>
            <li>
                <NavLink to="/promo-code"><em className="gg-promo"></em> Promo Code</NavLink>
            </li>
            <li>
                <NavLink to="/affiliate-login"><em className="gg-sign-out"></em> Logout</NavLink>
            </li>
        </ul>
    </aside>
  );
}
  
export default StoreSidebar;